export default "__VITE_ASSET__kjl0Z5Mg__"